module.exports = __webpack_public_path__ + "img/btn.a90f8ed5.png";